export default [
    {
      position: "absolute",
      top: 1.9,
      left: 27.8,
      class: "tooltips",
      animation: "pulsing",
      isTooltip: true,
      navPos: 1,
      tooltipText: "homeDashboard.persona3.ttTextOne",
      hover: false,
      tooltipClass: "bottom",
      id: "HR_Homepage_Navigation_TeamMember",
      index: 0,
    },
    {
      position: "absolute",
      top: 1.9,
      left: 34.1,
      class: "tooltips",
      animation: "pulsing",
      isTooltip: true,
      navPos: 5,
      tooltipText: "homeDashboard.persona3.ttTextThree",
      hover: false,
      tooltipClass: "bottom",
      id: "HR_Homepage_Navigation_Dashboard",
      index: 1,
    },
    {
      position: "absolute",
      top: 1.9,
      left: 39.2,
      class: "tooltips",
      animation: "pulsing",
      isTooltip: true,
      navPos: 3,
      tooltipText: "homeDashboard.persona3.ttTextTwo",
      hover: false,
      id: "HR_Homepage_Navigation_Reports",
      index: 2,
    },
    {
      position: "absolute",
      top: 3.4,
      left: 0.8,
      class: "tooltips",
      animation: "pulsing",
      isTooltip: true,
      navPos: 0,
      tooltipText: "homeDashRecruitP3.close",
      tooltipClass: "right",
      hover: false,
      id: "HR_Homepage_Navigation_Recruit",
      index: 3,
    },
    {
      position: "absolute",
      top: 60,
      left: 67.8,
      class: "tooltips",
      animation: "pulsing",
      isTooltip: true,
      navPos: 8,
      tooltipText: "homeDashRecruitP3.vacancies",
      hover: false,
      id: "HR_Homepage_Navigation_Recruit",
      index: 4,
    },
    {
      position: "absolute",
      top: 36,
      left: 9.8,
      class: "tooltips",
      animation: "pulsing",
      isTooltip: true,
      navPos: 9,
      tooltipText: "homeDashRecruitP3.candidatePortal",
      hover: false,
      id: "HR_Homepage_Navigation_Recruit",
      index: 5,
    },
  ];